import type { Profile } from "../profile.ts"
import type { Route } from "./+types/layout.ts"

import { Effect } from "effect"
import { Outlet } from "react-router"
import { Assets } from "../../../packages/assets.ts"
import { config } from "../../../packages/config.ts"
import { Footer } from "../../../packages/footer.tsx"
import { Handler } from "../../../server/handler.ts"
import { Res } from "../../../server/response.ts"
import { Header } from "../ui/header.tsx"
import stylesheet from "../ui/profile.css?url"

export const meta: Route.MetaFunction = () => [
  {
    title: `Profile | ${config.general.name}`,
  },
  {
    property: "og:title",
    content: `Profile | ${config.general.name}`,
  },
]

export const links: Route.LinksFunction = () => [{ rel: "stylesheet", href: stylesheet }]

type LoaderData = {
  user?: Profile.User
}

export const loader = Handler.make<LoaderData>("profile-layout", ({ api, sessions }) => {
  return sessions.authenticated.pipe(
    Effect.flatMap((session) => api.profile(session.user)),
    Effect.orElseSucceed(() => undefined),
    Effect.map((user) => Res.json({ user })),
  )
})

export default function ProfileLayout(props: Route.ComponentProps) {
  return (
    <div className="max-w-[var(--app-max-width)] w-full mx-auto">
      <div className="relative min-h-dvh flex flex-col text-foreground">
        <div className="absolute inset-0 w-full overflow-hidden select-none h-[55vh]">
          <img
            src={Assets.images.profileBackground}
            alt="Profile Background"
            className="size-full object-cover blur-md scale-110"
          />
          <div className="absolute inset-0 size-full bottom-0 left-0 bg-[linear-gradient(to_top,_var(--gray-1),_rgba(0,0,0,0.7))]" />
        </div>
        <Header user={props.loaderData.user} />
        <main className="flex-1 size-full flex flex-col z-10 mt-2">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  )
}
